import React from 'react';

// Product marks for the two Automation Vita products.
//
// MinutesBack's "return ribbon" is inlined from its own brand kit
// (~/Projects/MarcTrainNotifications/marketing/brand-kit/icon.svg) so the card
// carries the real mark without an image request. The icon lockup (navy tile) is
// used rather than the bare mark: at 44px the bare ribbon reads as a circular
// letter "P" — QA flagged it as a placeholder on 2026-09-16. SmartValueDirect ships as a
// PNG because its mark is a raster logo; the file is a copy of the one its own
// site serves. If either brand changes, re-copy from that product's brand kit —
// do not redraw here.

const MinutesBackMark = ({ size = 44, title = 'MinutesBack' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 120 120"
    width={size}
    height={size}
    role="img"
    aria-label={title}
  >
    <rect width="120" height="120" rx="26" fill="#14213D" />
    <path
      d="M 22 88 C 18 30, 102 22, 102 62 C 102 84, 78 96, 62 84"
      fill="none"
      stroke="#FAF7F0"
      strokeWidth="13"
      strokeLinecap="round"
    />
    <path
      d="M 78 70 L 56 78 L 66 100"
      fill="none"
      stroke="#F26B1D"
      strokeWidth="13"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="22" cy="88" r="9" fill="#2E7D4F" />
  </svg>
);

const SmartValueDirectMark = ({ size = 44, title = 'SmartValueDirect' }) => (
  <img
    src="/assets/smartvaluedirect-mark.png"
    alt={title}
    width={size}
    height={size}
    style={{ width: size, height: size }}
    loading="lazy"
    decoding="async"
  />
);

const marks = {
  minutesback: MinutesBackMark,
  smartvaluedirect: SmartValueDirectMark
};

const ProductMark = ({ mark, size = 44, title }) => {
  const Component = marks[mark];
  if (!Component) return null;
  return <Component size={size} title={title} />;
};

export default ProductMark;
